cb.define([], function () {
	var PC_pc_tagclass_VM_Extend = {
		doAction: function (name, viewmodel) {
		  if (this[name]) {
		    this[name](viewmodel);
		  }
		},
		init: function (viewmodel) {
		  	debugger;
	      	viewmodel.on('beforeSave', function(data) {
			  	debugger;
  				console.log(data)
	      	});
	      	viewmodel.on('beforeSaveandadd', function (data) {
			  	debugger;
  				console.log(data)
				return false
	      	});
		}
	}
  try {
    module.exports = PC_pc_tagclass_VM_Extend;
  } catch (error) {
  	// 当 类型 为 档案 的时候
  }
  return PC_pc_tagclass_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_tagclass_VM.Extend.js